import * as React from "react";
const SvgFiRrBoltSlash = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-bolt-slash_svg__a)">
      <path
        fill="#062147"
        d="m23.707 22.293-6.317-6.317 2.105-3.43a2.9 2.9 0 0 0 .163-2.995 2.9 2.9 0 0 0-2.569-1.547L13.256 8l1.205-5.227c.31-1.078-.139-2.172-1.064-2.6-.88-.407-1.865-.086-2.473.826L7.688 6.273 1.708.293A.999.999 0 1 0 .292 1.707l22 22a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414M12.548 2.177a1 1 0 0 1-.023.099l-1.5 6.5A1 1 0 0 0 12 10l5.09.004c.493 0 .725.338.802.483s.226.527-.076.974l-1.88 3.06L9.141 7.73zm2.356 17.847-1.83 2.979c-.432.65-1.057 1-1.699 1a1.8 1.8 0 0 1-.773-.174c-.925-.428-1.373-1.521-1.064-2.6l1.025-4.454a1 1 0 0 1 1.95.449l-1.04 4.504a1 1 0 0 0-.023.098l1.75-2.85a.999.999 0 1 1 1.703 1.047zM10 16.004H6.912a2.9 2.9 0 0 1-2.57-1.547 2.9 2.9 0 0 1 .163-2.996l.603-.984c.29-.47.906-.616 1.375-.33.471.29.618.906.33 1.377l-.627 1.022c-.302.446-.153.829-.076.975a.89.89 0 0 0 .803.483h3.088a1 1 0 1 1 0 2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-bolt-slash_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBoltSlash;
